var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-21 -291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar_Icon",
    "data-name": "Calendar/Icon",
    transform: "translate(25 296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1499",
    "data-name": "Rectangle 1499",
    width: 30,
    height: 30,
    transform: "translate(-4 -5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M21.905,17.24V3.448a1.623,1.623,0,0,0-1.623-1.623H19.269V.2a.2.2,0,1,0-.406,0V1.825h-2.84V.2a.2.2,0,1,0-.406,0V1.825h-2.84V.2a.2.2,0,0,0-.406,0V1.825H9.533V.2a.2.2,0,1,0-.406,0V1.825H6.288V.2a.2.2,0,1,0-.406,0V1.825H3.042V.2a.2.2,0,0,0-.406,0V1.825H1.623A1.623,1.623,0,0,0,0,3.448V17.24a1.623,1.623,0,0,0,1.623,1.623h18.66a1.623,1.623,0,0,0,1.623-1.623M1.623,18.457A1.218,1.218,0,0,1,.406,17.24V3.448A1.218,1.218,0,0,1,1.623,2.231H2.637V3.448a.2.2,0,0,0,.406,0V2.231h2.84V3.448a.2.2,0,0,0,.406,0V2.231h2.84V3.448a.2.2,0,1,0,.406,0V2.231h2.84V3.448a.2.2,0,0,0,.406,0V2.231h2.84V3.448a.2.2,0,1,0,.406,0V2.231h2.84V3.448a.2.2,0,1,0,.406,0V2.231h1.014A1.218,1.218,0,0,1,21.5,3.448V17.24a1.218,1.218,0,0,1-1.217,1.217Z",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M11.24,14.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H8.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H8.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H11.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,11.24,14",
    transform: "translate(-4.458 -8.321)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M11.24,24.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H8.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H8.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H11.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,11.24,24",
    transform: "translate(-4.458 -14.264)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M11.24,34.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H8.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H8.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H11.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,11.24,34",
    transform: "translate(-4.458 -20.208)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M25.24,14.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H22.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H22.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H25.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,25.24,14",
    transform: "translate(-12.778 -8.321)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M25.24,24.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H22.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H22.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H25.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,25.24,24",
    transform: "translate(-12.778 -14.264)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M25.24,34.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H22.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H22.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H25.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,25.24,34",
    transform: "translate(-12.778 -20.208)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M39.24,14.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H36.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H36.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H39.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,39.24,14",
    transform: "translate(-21.099 -8.321)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M39.24,34.406a.318.318,0,0,1,.317.317v1.8a.318.318,0,0,1-.317.317H36.222a.317.317,0,0,1-.316-.317v-1.8a.317.317,0,0,1,.316-.317Zm0-.406H36.222a.723.723,0,0,0-.722.722v1.8a.723.723,0,0,0,.722.722H39.24a.723.723,0,0,0,.722-.722v-1.8A.723.723,0,0,0,39.24,34",
    transform: "translate(-21.099 -20.208)",
    fill: "#256f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M37.626,27.268h0a.2.2,0,0,1-.144-.059L36.055,25.78a.2.2,0,0,1,.287-.287l1.284,1.285,2.668-2.668a.2.2,0,0,1,.287.287L37.77,27.208a.2.2,0,0,1-.144.059",
    transform: "translate(-21.394 -14.294)",
    fill: "#256f92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    transform: "translate(0 1.583)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.156,
    height: 17.408,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21.156,
    height: 16.408,
    rx: 1.5,
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5a96b757a32a36f3462be7ff6cce4c98.svg";
export { ForwardRef as ReactComponent };